<template>
	<div>
		
		<form action="https://new.colorwayrb.com/backend/download_bulk.php" method="GET" class="dw-form">
			
			<div class="dw-form__content-wrap">
				<div class="dw-form__side dw-form__side--left">
					<div class="input-group">
						<label for="" class="input-group__label">Customer</label>
						<select name="provider" id="provider" class="input-group__select">
							<option v-for="customer in customerList" v-bind:key="customer.id" v-bind:value="customer.value">{{ customer.text }}</option>
						</select>
					</div>
					<div class="input-group">
						<label for="" class="input-group__label">Size</label>
						<select name="size" id="size" class="input-group__select">
							<option value="">-- any --</option>
						</select>
					</div>
					<div class="input-group">
						<label for="" class="input-group__label">Time Section</label>
						<select name="timeselect" id="timeselect" class="input-group__select">
							<option value="">Whole Day</option>
						</select>
					</div>
				</div>
				<div class="dw-form__side dw-form__side--right">
					<div class="input-group">
						<label for="" class="input-group__label">Print Product</label>
						<select name="sku" id="sku" class="input-group__select">
							<option v-for="product in productList" v-bind:key="product.id" v-bind:value="product.value">{{ product.text }}</option>
						</select>
					</div>
					<div class="input-group">
						<label for="" class="input-group__label">Country Code</label>
						<select name="countrycode" id="countrycode" class="input-group__select">
							<option value="">-- any --</option>
						</select>
					</div>
					<div class="input-group">
						<label for="" class="input-group__label">Shipping Method</label>
						<select name="shipping_method" id="shipping_method" class="input-group__select">
							<option value="">-- any --</option>
						</select>
					</div>
				</div>
			</div>
			<input
				type="hidden"
				name="sessionid"
				v-model="sessionid"
				
			/>
			<input
				type="submit"
				value="REQUEST LINK"
				class="dw-form__submit btn btn--blue2"
				v-on:click="showLoading"
			/>
		</form>
	</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

export default Vue.extend({
	name: "DownloadReq",
	components: {},
	data() {
		return {
		customerList: {},
		productList: {},
		selected: '',
		sessionid: '',
		};
	},
	mounted() {
		{
			
			this.getTaskList();
			this.getProductList();
			
			this.sessionid = this.$store.getters.sessionid;
			
			
		}
	},
	methods: {
		getTaskList() {
			axios.get('https://new.colorwayrb.com/backend/customerlist.php').then(response => {
				this.customerList = response.data;
				console.log(response.data);
				
			});
		},
		
		getProductList() {
			axios.get('https://new.colorwayrb.com/backend/productlist.php').then(response => {
				this.productList = response.data;
				console.log(response.data);
				
			});
		},
		
		showLoading() {
			let loader = this.$loading.show({
                  // Optional parameters
                  container: null,
                  canCancel: false,
                  
                });
		}
	}
});
</script>

<style lang="scss" scoped>
.dw-form {
	&__content-wrap {
		display: flex;
		justify-content: center;
		padding-bottom: 40px;
		padding-top: 40px;
	}

	&__side--left {
		margin-right: 40px;
	}

	&__submit {
		margin: 0 auto 60px;
		border-radius: 5px;
		display: block;
		height: 36px;
		width: 160px;
	}
}

.input-group {
	padding: 8px 0;
	//
	&__label {
		display: inline-block;
		font-size: 16px;
		width: 155px;
	}

	&__select {
		box-shadow: 1px 1px 1px $border-color;
		text-transform: uppercase;
		text-align-last: center;
		font-weight: bold;
		border: none;

		border-radius: 5px;
		font-size: 12px;
		height: 30px;
		width: 150px;
	}
}
</style>
